(function () {
  const reviewSelector =
    '.mobile-grid--two-columns .yotpo-sr-bottom-line-text';
  const priceSelector =
    '.mobile-grid--two-columns .product-title-and-price > .price-ui:not(.price-ui--loading) .money';

  function collectElements(scope, selector) {
    const elements = [];

    if (scope.matches && scope.matches(selector)) {
      elements.push(scope);
    }

    elements.push.apply(elements, scope.querySelectorAll(selector));

    return elements;
  }

  function formatReviewCounts(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const elements = collectElements(scope, reviewSelector);

    elements.forEach(function (element) {
      const text = element.textContent.trim();
      const match = text.match(/[0-9][0-9,.]*/);

      if (!match) return;

      const formattedCount = '(' + match[0] + ')';

      if (text !== formattedCount) {
        element.textContent = formattedCount;
      }
    });
  }

  function formatPrices(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const elements = collectElements(scope, priceSelector);

    elements.forEach(function (element) {
      const text = element.textContent.trim();
      const match = text.match(/[0-9][0-9,.]*/);

      if (!match) return;

      const currency = text.replace(match[0], '').trim();

      if (!currency) return;

      const amount = match[0].replace(/[.,]00$/, '');
      const formattedPrice = currency + amount;

      if (text !== formattedPrice) {
        element.textContent = formattedPrice;
      }
    });
  }

  function formatMobileCardContent(root) {
    formatReviewCounts(root);
    formatPrices(root);
  }

  function initializeMobileCardContent() {
    formatMobileCardContent(document);

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          formatMobileCardContent(mutation.target.parentElement);
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            formatMobileCardContent(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMobileCardContent);
  } else {
    initializeMobileCardContent();
  }
})();
